import React from 'react'
import { FastField } from 'utils-next/forms'

import AutoComplete, { AutoCompleteProps } from './AutoComplete.component'

const AutoCompleteFormik = (props: AutoCompleteProps) => (
  <FastField key={props.dataType} component={AutoComplete} {...props} />
)

export default AutoCompleteFormik
